function getUserAgent() {
  return typeof navigator === "undefined" ? "" : navigator.userAgent;
}

export function isAndroid() {
  return /android/i.test(getUserAgent());
}

// eslint-disable-next-line complexity
export function isTablet() {
  const userAgent = getUserAgent();
  const isIpad = /iPad/.test(userAgent);
  // iPadOS detection: Macintosh UA + touch support
  // Must check for actual touch capability (ontouchend) to exclude desktop Macs with trackpads
  const isIpadOS =
    /Macintosh/.test(userAgent) &&
    navigator.maxTouchPoints > 1 &&
    "ontouchend" in document;
  const isAndroidTablet = isAndroid() && !/mobile/i.test(userAgent);

  return isIpad || isIpadOS || isAndroidTablet;
}
